import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';
import {
  createMoreThanOneInstallment,
  createOneInstallment,
  deleteOneInstallment,
  getOneInstallment,
  updateOneInstallment,
  useGetInstallmentMoreThanOne,
} from './Installment.service';
import {
  CreateMoreThanOneInstallment,
  CreateOneInstallment,
  UpdateOneInstallment,
} from './Installment.types';
import { notification } from 'antd';
import { useServiceError } from '@/hooks';

export function useGetAllInstallmentInvoice(id: number) {
  const query = useInfiniteQuery(['installmentAll'], () =>
    useGetInstallmentMoreThanOne(id),
  );

  useServiceError(query.error);

  return query;
}

export function useCreateOneInstallment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: CreateOneInstallment) => createOneInstallment(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcela criado!',
        });

        queryClient.invalidateQueries(['installmentAll']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useCreateMoreThanOneInstallment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: CreateMoreThanOneInstallment) => createMoreThanOneInstallment(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcelas criadas!',
        });

        queryClient.invalidateQueries(['installmentAll']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateOneInstallment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: UpdateOneInstallment) => updateOneInstallment(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcela editada!',
        });

        queryClient.invalidateQueries(['installmentAll']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useGetOneBillingInvoice() {
  const mutation = useMutation(
    ({ invoiceId, id }: { invoiceId: number; id: number }) =>
      getOneInstallment({ invoiceId, id }),
  );

  useServiceError(mutation.error);
  return mutation;
}

export function useDeleteInstallmentInvoice() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ invoiceId, id }: { invoiceId: number; id: number }) =>
      deleteOneInstallment({ invoiceId, id }),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Parcela deletada!',
        });

        queryClient.invalidateQueries(['installmentAll']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
